// Bespoke
jQuery(document).ready(function($) {

	// Wishlist
	function getWishlistId() { for (var i = decodeURIComponent(document.cookie).split(";"), t = 0; t < i.length; t++) { for (var n = i[t];
				" " == n.charAt(0);) n = n.substring(1); if (0 == n.indexOf("wishlist_id=")) return n.substring("wishlist_id=".length, n.length) } }

	
	var wishlistURL = "/a/wishlist?type=api&wishlistid=" + getWishlistId() + "&version=1"; 
    
	var $wishlistContainer = $('.wishlist-scroll');
	var $wishlistAddAll = $('.button-wishlist-add');
	var wishlistHTML = '';
	var wishlistData = false;

	// Wishlist : Add All
	$wishlistAddAll.on('click', function(e) {
		e.preventDefault();

		if (wishlistData) {

			$wishlistAddAll.addClass('loading');

			var i = 0;

			$.each(wishlistData.items, function(key, value) {
				CartJS.addItem(value.variant_id, 1);
			});
		}
	});

	// Wishlist : Update  
	function wishlistUpdate(wishlistURL) {
		$.ajax({
			url: wishlistURL,
			dataType: "json",
			cache: false,
			success: function(data) {

				if (parseInt(data.count) == 0) {
					// Empty 
					$wishlistContainer.html('<p>Your wishlist is empty.</p>');
				} else if (wishlistData == data) {
					// No change
					console.log('no change');
				} else {

					wishlistHTML = '<table cellpadding="0" cellspacing="0" class="minicart-table">';


					$.each(data.items, function(key, value) {
						var product_url = "/products/" + value.handle;
						var product_title = value.title;
						var product_image = value.image;
						var variant_title = value.variant_title;
						var variant_price = Shopify.formatMoney(value.variant_price);

						// Replace $ for £ - can't pass 2nd parameter to formatMoney, so always returns dollars :|
						variant_price = variant_price.replace('$', '£');

						wishlistHTML += '<tr class="minicart-item" data-id="' + value.id + '">';
						wishlistHTML += '<td class="minicart-image"><a href="' + product_url + '" class="image-container" style="padding-top:62.22%;"><img class="lazy" data-src="' + product_image + '"></a></td>';
						wishlistHTML += '<td class="minicart-product f-16">';
						wishlistHTML += '<a href="' + product_url + '" class="minicart-product-title bold">' + product_title + '</a>';
						wishlistHTML += '<p class="minicart-variant-title">' + variant_title + '</p>';
						wishlistHTML += '<p class="minicart-price">' + variant_price + '</p>';
						wishlistHTML += '</td>';
						wishlistHTML += '</tr>';
					});

					wishlistHTML += '</table>';

					// Update HTML
					$wishlistContainer.html(wishlistHTML);

					// Update lazyload for cart images
					if (lazyLoadInstance) {
						lazyLoadInstance.update();
					}
				}

				// Cache response
				wishlistData = data;
			}
		});
	}

	$(document).on('showWishlist', function(event, cart) {
		wishlistUpdate(wishlistURL);
	});

	// Mini cart
    var $headerMask = $('.header-mask');
	var $headerPanel = $('.header-panel');
    var $headerMenuLinks = $('.menu-primary-item');
    var $headerMenuBasketLink = $('.menu-secondary-item-basket');
	var $basketCount = $('.menu-secondary-item-count');
	var $miniCartEmpty = $('.minicart-empty');
	var $miniCart = $('.header-minicart');
    var $miniCartClose = $('.button-minicart-close');
	var cachedCartState = false;

	$(document).on('cart.ready', function(event, cart) {
		// Cache state, to avoid recursion
		cachedCartState = JSON.stringify(cart.items);
	});

	$(document).on('cart.requestStarted', function(event, cart) {
		cachedCartState = JSON.stringify(cart.items);
	});

	$(document).on('cart.requestComplete', function(event, cart) {

		// Update Basket count
		$basketCount.html(cart.item_count);

		// Gift wrapping logic, only run when changes, otherwise recusion :|      
		if (cachedCartState === JSON.stringify(cart.items)) {
			if (console) console.log('cart unchanged');
		} else {
			if (console) console.log('cart changed, update Gift Wrapping');
			cartGiftWrapping();
		}

		if (cart.item_count == 0) {
			$miniCart.add('.shopping-basket').addClass('is-empty');
		} else {
			$miniCart.add('.shopping-basket').removeClass('is-empty');
		}

		// Show minicart
		if (!$('body').hasClass('template-cart')) {
			$headerMenuBasketLink.addClass('active');
            $headerMask.addClass('is-active');
			$miniCart.addClass('is-visible');

            // Close menu
            $headerMenuLinks.removeClass('is-active');
		}

		// Refresh Images
		if (lazyLoadInstance) {
			lazyLoadInstance.update();
		}

		// ScrollTop
		$("html, body").animate({ scrollTop: 0 }, 300);

		// Remove wishlist loading state
		$wishlistAddAll.removeClass('loading');

	});

    // Header : Basket : Show minicart
    $headerMenuBasketLink.on('click', function(e) {
      e.preventDefault();
      if ( $(this).hasClass('is-active') )  {
        $headerMenuBasketLink.removeClass('is-active');
        $headerMask.removeClass('is-active');
        $miniCart.removeClass('is-visible');
      } else {
        $headerMenuBasketLink.addClass('is-active');
        $headerMask.addClass('is-active');
        $miniCart.addClass('is-visible');
       
        // Close menu
        $headerMenuLinks.removeClass('is-active');
      }
    });

    // Header : Basket : Close
    $miniCartClose.on('click', function(e) {
        e.preventDefault();
        $headerMenuBasketLink.removeClass('is-active');
        $headerMask.removeClass('is-active');
        $miniCart.removeClass('is-visible');
    });
  
	function cartGiftWrapping() {

		giftWrappingProductID = 33049182601296;
		giftWrappingProductQuantity = 0;
		giftWrappingCount = 0;
		giftWrappingRequired = false;
		hasGiftWrappingProduct = false;


		if (typeof CartJS.cart != 'undefined') {
			if (CartJS.cart.item_count > 0) {
				CartJS.cart.items.forEach(function(item) {                  
					if (item.id == giftWrappingProductID) {
						// Does the cart contain the gift wrapping product
						hasGiftWrappingProduct = true;
						giftWrappingProductQuantity = item.quantity;
					} else if (item.properties['Gift Wrapping'] == 'Yes') {
						// Does this item have gift wrapping
						giftWrappingRequired = true;
						giftWrappingCount = giftWrappingCount + (1 * item.quantity);
					}
				});

				// Does the cart have gift wrapping
				if (giftWrappingRequired && hasGiftWrappingProduct) {
					// Does the quantity required match
					if (giftWrappingCount != giftWrappingProductQuantity) {
						// Update the quantity
						CartJS.updateItemById(giftWrappingProductID, giftWrappingCount);
						if (console) console.log('Giftwrapping required, update quantity');
					}
				} else if (giftWrappingRequired && !hasGiftWrappingProduct) {
					// Add the gift wrapping
					CartJS.addItem(giftWrappingProductID, giftWrappingCount);
					if (console) console.log('Giftwrapping required, add');
				} else if (!giftWrappingRequired && hasGiftWrappingProduct) {
					// Gift wrapping not needed, remove it
					CartJS.removeItemById(giftWrappingProductID);
					if (console) console.log('Giftwrapping not required, remove');
				}

				lazyLoadInstance.update();
			}
		}
	}

	// Cart 
	if ($('body').hasClass('template-cart')) {
		if (document.referrer) {
			$('.basket-continue').attr('href', document.referrer);
		}

		$quantityButtons = $('.quantity-button');
		$quantityButtons.on('click', function(e) {
			e.preventDefault();
			var $quantity = $(this).parent().find("input");
			var value = $quantity.val();
			if ($(this).hasClass('quantity-plus')) {
				$quantity.val(parseFloat(value) + 1);
			} else {
				if (value >= 1) {
					$quantity.val(parseFloat(value) - 1);
				}
			}
		});

        // Update stock messaging if product is 'continue' to sell
        jQuery(document).on('cart.ready', function(event, cart) {
          updateCartStock(cart);
		  updateCartLeadtime(cart);
        });
        jQuery(document).on('cart.requestComplete', function(event, cart) {
          updateCartStock(cart);
		  updateCartLeadtime(cart);
        });

        function updateCartStock(cart) {
          $cartProducts = $('.cart-product');          
          for (var i = 0; i < scp_inventory.length; i++) {
            $cartProducts.each(function(e) {
			// TODO - Update
            //   if ($(this).data('id') == scp_inventory[i][0] ) {
            //     if ( ( parseInt($(this).find('.quantity-input').val()) > scp_inventory[i][1] ) || scp_inventory[i][1] == 0 ) {
            //       $(this).addClass('has-stock-message');
            //       $(this).find('.cart-stock-message').text($(this).find('.cart-stock-message').data('text').replace('**stock**', scp_inventory[i][1]));
            //     } else {
            //       $(this).removeClass('has-stock-message');
            //     }
            //   } 
            });
          }
        }
        function updateCartLeadtime(cart) {
          $cartProducts = $('.cart-product');          
          $cartProducts.each(function(e) {
			let variant_id = $(this).data('id');
			let lead_time = false;
			for (var i = 0; i < cartVariantLeadTimes.length; i++) {
				if (cartVariantLeadTimes[i].id === variant_id) {
					lead_time = cartVariantLeadTimes[i].lead_time;
				}
			}
			if ( lead_time ) {
				$(this).find('.cart-leadtime-label').text('Lead time: ' + lead_time);
			}
          });
        }

	}

	if ($('body').hasClass('template-index') || $('body#new-in').length || $('body#art-pieces').length || $('body#contracts-landing-page').length || $('body#scp-contracts-landing-page').length) {

		initHomepage(false);

		$(document).on('shopify:section:load', function(e) {
			initHomepage(true);
		});


		function initHomepage(triggerLazy) {

			// Refresh Images
			if (lazyLoadInstance) {
				lazyLoadInstance.update();
			}

			// Slideshows
			$('.layout-slideshow').each(function(e) {
				const slideshow = new Swiper($(this).find('.swiper').get(0), {
					loop: true,
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					spaceBetween: 0,
				});
				slideshow.on('slideChange', function() {
					// Update Lazyload
					if (lazyLoadInstance) {
						lazyLoadInstance.update();
					}
				});

			});


			// Product Sliders
			$('.layout-product-slider').each(function(e) {
				const productSlider = new Swiper($(this).find('.swiper').get(0), {
					loop: true,
					navigation: {
						nextEl: '.product-slider-next',
						prevEl: '.product-slider-prev',
					},
					slidesPerView: 6,
					spaceBetween: 24,
					breakpoints: {
						0: {
							slidesPerView: 2,
						},
						800: {
							slidesPerView: 4,
						},
						1220: {
							slidesPerView: 6,
						}
					},
                  on: {
                    init: function (swiper) {
                        // Adjust arrow position
                        $(swiper.el).find('.swiper-button-next, .swiper-button-prev').css('bottom', ($(swiper.el).find('.border').height() + 16));
                    },
                  },
				});
			});

			// Collection Product Sliders
			$('.home-collection-slider').each(function(e) {
				$(this).owlCarousel({
					center: false,
					items: 4,
					loop: true,
					margin: 0,
					nav: true,
					lazyLoad: false,
					navText: ['', ''],
					itemElement: 'a',
					responsive: {
						// breakpoint from 480 up
						400: {
							nav: false,
							items: 2,
							dots: true
						},
						// breakpoint from 480 up
						800: {
							nav: false,
							items: 3,
							dots: true
						},
						// breakpoint from 1024 up
						1220: {
							nav: true,
							items: 4,
							dots: false
						}
					}
				}).on('translated.owl.carousel', function(event) {

					// Update Lazyload
					if (lazyLoadInstance) {
						lazyLoadInstance.update();
					}
				});
			});
		}
	}
});